import React from "react";
import { DialogWindow } from "./DialogWindow";
import { Button, capitalize, Stack, Typography } from "@mui/material";

export const ErrorWindow = ({ error, handleClose }) => (
  <DialogWindow
    title={
      <Typography
        color={"primary"}
        sx={{ fontWeight: "bold", fontSize: "1.4em" }}
      >
        Oops!
      </Typography>
    }
    content={
      <Typography mt={2} mb={2} color={"textPrimary"}>
        {capitalize(error)}
      </Typography>
    }
    handleClose={handleClose}
    withCloseButton
    actions={
      <Stack justifyContent={"center"} alignItems={"center"} width={"100%"}>
        <Button variant="contained" onClick={handleClose}>
          Got it
        </Button>
      </Stack>
    }
  />
);
